(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-article-template"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seo-article-template')) {
    customElements.define('seo-article-template', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const listen = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });
        const content = this.querySelector('.seo-article-content');
        const toc = this.querySelector('.seo-article-toc__list');
        const links = Array.from(toc?.querySelectorAll('a') || []);
        const headings = links.map(link => document.getElementById(decodeURIComponent(link.hash.slice(1)))) ;
        let locked = false;
        const setExpanded = (item, expanded) => {
          const button = item.querySelector('.seo-article-toc__toggle');
          const children = item.querySelector('.seo-article-toc__sublist');
          if (!button || !children) return;
          button.setAttribute('aria-expanded', String(expanded));
          children.setAttribute('aria-hidden', String(!expanded));
          children.hidden = !expanded;
        };
        const activate = (link) => {
          if (!link) return;
          links.forEach(other => {
            other.classList.toggle('is-active', other === link);
            if (other === link) other.setAttribute('aria-current', 'location');
            else other.removeAttribute('aria-current');
          });
          const parent = link.closest('.seo-article-toc__item--level-2');
          toc.querySelectorAll('.seo-article-toc__item--level-2').forEach(item => setExpanded(item, item === parent));
          const listRect = toc.getBoundingClientRect();
          const linkRect = link.getBoundingClientRect();
          if (linkRect.top < listRect.top) toc.scrollTop -= listRect.top - linkRect.top + 8;
          else if (linkRect.bottom > listRect.bottom) toc.scrollTop += linkRect.bottom - listRect.bottom + 8;
        };
        listen(toc, 'click', event => {
          const toggle = event.target.closest('.seo-article-toc__toggle');
          if (toggle) {
            setExpanded(toggle.closest('.seo-article-toc__item--level-2'), toggle.getAttribute('aria-expanded') !== 'true');
            return;
          }
          const link = event.target.closest('a');
          if (link) { locked = true; activate(link); }
        });
        const sync = () => {
          this.frame = null;
          if (locked || !links.length || !toc.getClientRects().length) return;
          const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          let active = links[0];
          headings.forEach((heading, index) => { if (heading && heading.getBoundingClientRect().top <= header + 64) active = links[index]; });
          activate(active);
        };
        const requestSync = () => { if (!this.frame) this.frame = requestAnimationFrame(sync); };
        listen(window, 'scroll', requestSync, { passive: true });
        listen(window, 'wheel', () => { locked = false; }, { passive: true });
        listen(window, 'touchmove', () => { locked = false; }, { passive: true });
        listen(window, 'keydown', event => {
          if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key) && !event.target.closest('input,textarea,select,button,[contenteditable]')) locked = false;
        });
        listen(window, 'hashchange', () => {
          const selected = links.find(link => link.hash === location.hash);
          if (selected) { locked = true; activate(selected); }
        });
        listen(toc, 'wheel', event => {
          const atEdge = event.deltaY < 0 ? toc.scrollTop <= 0 : toc.scrollTop + toc.clientHeight >= toc.scrollHeight - 1;
          toc.style.overscrollBehaviorY = atEdge ? 'auto' : 'none';
        }, { passive: true });
        let tocTouchY;
        listen(toc, 'touchstart', event => { tocTouchY = event.touches[0].clientY; }, { passive: true });
        listen(toc, 'touchmove', event => {
          const delta = tocTouchY - event.touches[0].clientY;
          const atEdge = delta < 0 ? toc.scrollTop <= 0 : toc.scrollTop + toc.clientHeight >= toc.scrollHeight - 1;
          toc.style.overscrollBehaviorY = atEdge ? 'auto' : 'none';
        }, { passive: true });
        if (links.length) {
          activate(links.find(link => link.hash === location.hash) || links[0]);
          if (location.hash) locked = true;
          else sync();
        }

        const copy = this.querySelector('[data-copy-url]');
        const copyLabel = copy?.querySelector('[data-copy-label]');
        const initialLabel = copyLabel?.textContent;
        listen(copy, 'click', async () => {
          const status = this.querySelector('[data-copy-status]');
          let feedback;
          try {
            await navigator.clipboard.writeText(copy.dataset.copyUrl);
            feedback = this.dataset.copySuccess;
          } catch { feedback = this.dataset.copyError; }
          if (!this.isConnected) return;
          copyLabel.textContent = feedback;
          status.textContent = feedback;
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => { copyLabel.textContent = initialLabel; status.textContent = ''; }, 3000);
        });

        const tables = Array.from(content?.querySelectorAll('table') || []);
        const refreshTables = () => tables.forEach(table => {
          const wrapper = table.parentElement;
          wrapper.dataset.overflow = String(table.scrollWidth > wrapper.clientWidth + 1);
          wrapper.tabIndex = table.scrollWidth > wrapper.clientWidth + 1 ? 0 : -1;
        });
        tables.forEach(table => {
          let wrapper = table.parentElement;
          if (!wrapper.matches('.seo-article-table-scroll,.table-wrapper')) {
            wrapper = document.createElement('div');
            table.before(wrapper);
            wrapper.append(table);
          }
          while (wrapper.parentElement.matches('.seo-article-table-scroll,.table-wrapper')) {
            const outer = wrapper.parentElement;
            wrapper.replaceWith(...wrapper.childNodes);
            wrapper = outer;
          }
          wrapper.classList.add('seo-article-table-scroll', 'table-wrapper');
          wrapper.dataset.swipeHint = this.dataset.tableHint;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-label', table.caption?.textContent || 'Scrollable table');
        });
        this.tableObserver = new ResizeObserver(refreshTables);
        tables.forEach(table => this.tableObserver.observe(table.parentElement));
        refreshTables();

        const module = this.querySelector('.seo-article-recommended-products');
        if (!module) return;
        const track = module.querySelector('.seo-article-recommended-products__track');
        const slides = Array.from(module.querySelectorAll('.seo-article-recommended-products__slide'));
        const dots = Array.from(module.querySelectorAll('[data-slide]'));
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let index = 0;
        let hovered = false;
        const stop = () => { clearTimeout(this.carouselTimer); };
        const schedule = () => {
          stop();
          if (module.dataset.layout !== 'carousel' || slides.length < 2 || module.hidden || reduced.matches || document.hidden || hovered || module.contains(document.activeElement) || module.dataset.autoplay !== 'true') return;
          this.carouselTimer = setTimeout(() => show(index + 1), Number(module.dataset.interval) || 5000);
        };
        const show = next => {
          if (!track || !slides.length) return;
          index = (next + slides.length) % slides.length;
          track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
          slides.forEach((slide, number) => {
            const active = number === index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.inert = !active;
          });
          dots.forEach((dot, number) => {
            if (number === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          schedule();
        };
        listen(module.querySelector('.seo-article-recommended-products__previous'), 'click', () => show(index - 1));
        listen(module.querySelector('.seo-article-recommended-products__next'), 'click', () => show(index + 1));
        dots.forEach(dot => listen(dot, 'click', () => show(Number(dot.dataset.slide))));
        listen(module, 'pointerenter', () => { hovered = true; stop(); });
        listen(module, 'pointerleave', () => { hovered = false; schedule(); });
        listen(module, 'focusin', stop);
        listen(module, 'focusout', () => queueMicrotask(schedule));
        listen(document, 'visibilitychange', schedule);
        listen(reduced, 'change', schedule);
        let touchStart;
        listen(track, 'touchstart', event => { touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY }; stop(); }, { passive: true });
        listen(track, 'touchend', event => {
          if (!touchStart) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
          else schedule();
          touchStart = null;
        }, { passive: true });
        listen(track, 'touchcancel', () => { touchStart = null; schedule(); }, { passive: true });
        listen(module.querySelector('.seo-article-recommended-products__close'), 'click', () => {
          const aside = module.closest('aside');
          const adjacent = aside.querySelector('.seo-article-toc__link');
          if (adjacent && adjacent.getClientRects().length) adjacent.focus({ preventScroll: true });
          else aside.focus({ preventScroll: true });
          stop();
          module.hidden = true;
        });
        show(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.tableObserver?.disconnect();
        clearTimeout(this.carouselTimer);
        clearTimeout(this.copyTimer);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
